import {Box, Typography, useMediaQuery, useTheme} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {ContactNameField, ContactPhoneField} from './ContactFormFields'

type Props = {
  userProfileCountry?: string
}

/**
 * Contact details section for RMC order intake
 * Includes order placer and site contact information with required fields
 */
export const ContactSection: React.FC<Props> = ({userProfileCountry}) => {
  const {t} = useTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const countryCode = userProfileCountry || 'US'

  return (
    <Box>
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontWeight: 600,
          fontSize: '18px',
          lineHeight: '24px',
          color: '#29333D',
          marginBottom: '20px'
        }}
      >
        {t('orderIntake.contactDetails')}
      </Typography>

      <Box
        display="flex"
        sx={
          isMobile
            ? {flexDirection: 'column', rowGap: 2}
            : {flexWrap: 'wrap', justifyContent: 'space-between'}
        }
      >
        {/* Order Placer Name */}
        <ContactNameField
          fieldName="orderPlacer.name"
          label={t(
            'orderIntake.rmc.orderManagement.orderSummary.contactValidation.orderPlacerName',
            'Order Placer Name'
          )}
          testId="order-intake-order-placer-name"
          width={isMobile ? '100%' : '45%'}
        />

        {/* Order Placer Phone */}
        <ContactPhoneField
          fieldName="orderPlacer.phoneNumber"
          label={t(
            'orderIntake.rmc.orderManagement.orderSummary.contactValidation.orderPlacerPhone',
            'Order Placer Phone'
          )}
          countryCode={countryCode}
          testId="order-intake-order-placer-phone"
          width={isMobile ? '100%' : '45%'}
        />

        {/* Site Contact Name */}
        <ContactNameField
          fieldName="siteContact.name"
          label={t(
            'orderIntake.rmc.orderManagement.orderSummary.contactValidation.siteContactName',
            'Site Contact Name'
          )}
          testId="order-intake-site-contact-name"
          width={isMobile ? '100%' : '45%'}
        />

        {/* Site Contact Phone */}
        <ContactPhoneField
          fieldName="siteContact.phoneNumber"
          label={t(
            'orderIntake.rmc.orderManagement.orderSummary.contactValidation.siteContactPhone',
            'Site Contact Phone'
          )}
          countryCode={countryCode}
          testId="order-intake-site-contact-phone"
          width={isMobile ? '100%' : '45%'}
        />
      </Box>
    </Box>
  )
}
